import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { NgxGoToastComponent } from '@go-modules/components/go-toast/go-toast.component';
import { NgxGoToastService } from '@go-modules/services/go-toast/go-toast.service';

export const ngxGoToastModule = angular.module('ngxGoToastModule', [])
	.directive('ngxGoToast', downgradeComponent({ component: NgxGoToastComponent }))
	.factory('ngxGoToastService', downgradeInjectable(NgxGoToastService) as any)
	.name;
